import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TrustSection = () => {
  const testimonials = [
  {
    name: 'Dra. Luciana Milfont',
    role: 'Psicóloga Clínica',
    avatar: `${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/public-images/LucianaMilfont.jpg`,
    avatarAlt: 'Professional headshot of Brazilian woman with brown hair in clinical setting',
    content: `O ${import.meta.env.VITE_APP_TITLE} transformou completamente minha prática. A automação de WhatsApp reduziu minhas faltas em 65% e agora tenho mais tempo para focar nos meus pacientes.`,
    rating: 5
  },
  {
    name: 'Dra. Luciana Milfont',
    role: 'Psicóloga Clínica',
    avatar: `${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/public-images/LucianaMilfont.jpg`,
    avatarAlt: 'Professional headshot of Brazilian woman with brown hair in clinical setting',
    content: 'A página de agendamento público foi um divisor de águas. Meus pacientes adoram a facilidade de marcar consultas online e eu economizo horas de ligações telefônicas.',
    rating: 5
  },
  {
    name: 'Dra. Luciana Milfont',
    role: 'Psicóloga Clínica',
    avatar: `${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/public-images/LucianaMilfont.jpg`,
    avatarAlt: 'Professional headshot of Brazilian woman with brown hair in clinical setting',
    content: 'Os relatórios detalhados me ajudam a entender melhor meu negócio. Consigo ver padrões de agendamento e otimizar minha agenda para maximizar receita.',
    rating: 5
  }];


  const badges = [
  {
    icon: 'Shield',
    title: 'LGPD Compliant',
    description: 'Dados protegidos'
  },
  {
    icon: 'Lock',
    title: 'Criptografia SSL',
    description: 'Segurança total'
  },
  {
    icon: 'Award',
    title: 'Segue Regras do',
    description: 'Conselho Federal'
  },
  {
    icon: 'Users',
    title: '2.500+ Psicólogos',
    description: 'Confiam em nós'
  }];


  return (
    <section className="py-20 px-6 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-success/10 rounded-full mb-4">
            <Icon name="Heart" size={16} color="var(--color-success)" />
            <span className="text-sm font-medium text-success">
              Confiança e Segurança
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Psicólogos confiam no {import.meta.env.VITE_APP_TITLE}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Junte-se a milhares de profissionais que já transformaram suas práticas
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {badges?.map((badge, index) =>
          <div
            key={index}
            className="bg-card rounded-xl p-6 border border-border text-center hover:shadow-soft transition-shadow">

              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name={badge?.icon} size={24} color="var(--color-primary)" />
              </div>
              <h3 className="text-lg font-semibold text-foreground mb-1">
                {badge?.title}
              </h3>
              <p className="text-sm text-muted-foreground">
                {badge?.description}
              </p>
            </div>
          )}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials?.map((testimonial, index) =>
          <div
            key={index}
            className="bg-card rounded-2xl p-8 border border-border hover:shadow-elevated transition-all duration-300">

              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial?.rating)]?.map((_, i) =>
              <Icon
                key={i}
                name="Star"
                size={16}
                color="var(--color-warning)"
                className="fill-current" />

              )}
              </div>

              <p className="text-muted-foreground leading-relaxed mb-6">
                "{testimonial?.content}"
              </p>

              <div className="flex items-center gap-4">
                <Image
                src={testimonial?.avatar}
                alt={testimonial?.avatarAlt}
                className="w-12 h-12 rounded-full object-cover" />

                <div>
                  <p className="font-semibold text-foreground">
                    {testimonial?.name}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    {testimonial?.role}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default TrustSection;